import { apiBaseUrl } from 'services/config';

export async function authenticateAdminGrant(
  token: string,
  adminGrantJwt: string,
): Promise<{ sessionToken: string; sessionJwt: string } | null> {
  try {
    const response = await fetch(`${apiBaseUrl}/admin-auth/authenticate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, adminGrantJwt }),
    });
    if (!response.ok) return null;
    const data = await response.json();
    return data?.sessionToken && data?.sessionJwt ? data : null;
  } catch {
    return null;
  }
}
